export default __webpack_public_path__ + "static/media/CNo.42-2.e6cc4a5f.jpg";